module.exports = __webpack_public_path__ + "static/img/shiye_img8@2x.ed60dd8a.jpg";